<template>
  <div>
    <div v-if="status === 1">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span class="text-primary">{{ $t('results.Processing') }}</span>
    </div>
    <div v-if="status === 2">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span class="text-primary">{{ $t('results.Generating') }}<span /></span>
    </div>
    <div v-if="status === 3">
      <span class="text-success">{{ $t('results.Complete') }}</span>
    </div>
    <div v-if="status === 4">
      <span class="text-danger">{{ $t('results.Failed') }}</span>
    </div>
    <div v-if="status === 5">
      <span class="text-warning">{{ $t('results.CompletedInspectionRequired') }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StatusDisplay',
  props: {
    status: {
      type: Number,
      required: true,
      default: 3
    }
  }
};
</script>
<style></style>
